import topicsTemplate from "./topics.html";
import { SPANISH, ENGLISH } from "../../../../app.constants";
import { print, getCloudinaryUrl } from "../../../common/common.utils";
import { TEXT, SLIDES, VIDEO } from "../../constants";
import en from "./en.json";
import es from "./es.json";
import _ from "lodash";

import logoUrl from "../../../../../assets/harvust-logo-008.svg";
import mixpanel from "mixpanel-browser";

class PublicSafetyMeetingTopicListController {
    /* @ngInject */
    constructor($http) {
        this.SPANISH = SPANISH;
        this.ENGLISH = ENGLISH;
        this.TEXT = TEXT;
        this.SLIDES = SLIDES;
        this.VIDEO = VIDEO;
        this.$http = $http;
        this.LOGO_URL = logoUrl;
    }

    $onInit() {
        let ctrl = this;
        console.log(ctrl.topics);
        ctrl.popular = _.slice(
            _.orderBy(ctrl.topics, "usage_count", "desc"),
            0,
            3,
        );
    }
}
export default {
    bindings: { topics: "<" },
    controller: PublicSafetyMeetingTopicListController,
    template: topicsTemplate,
    name: "publicSafetyMeetingTopicList",
    translations: { en, es },
};
